import React from 'react';
import { connect } from 'dva';
import { Menu, Layout,Button ,Select } from 'antd';
import ScrollComponent from './scroll'
import Less from './scroll.module.less'
// LockOutlined, HomeOutlined, ReloadOutlined,
import { UserOutlined,  MenuUnfoldOutlined, MenuFoldOutlined, PoweroffOutlined } from '@ant-design/icons';
import {routerRedux,} from 'dva/router';
import classNames from 'classnames/bind';
import { AsynMenu } from 'components';
import { storage } from 'utils';
import PropTypes from 'prop-types';
import styles from './baseLayout.module.less';
// import { controllerFile } from 'controller';
import {Spin,message,} from 'antd';
import controllerUserAPI from 'controller/userAPI';
import controllerUser from 'controller/user';
import ModifyPwd from './ModifyPwd';
import axios from 'axios';
// const { TabPane } = Tabs;
const { Header, Content, Footer, Sider } = Layout;
// const getWindowHeight = t => window.outerHeight > window.innerHeight ? window.outerHeight : window.innerHeight;
const getWindowHeight = t => document.body.clientHeight;
const cx = classNames.bind(styles)
let addEvent = function () {
  let me = this;
  window.MenuAnchorTo = (code, url) => {
    const { menusObj } = me.props;
    const key = /^\//.test(code) ? code : `/${code}`;
    const menu = menusObj[key];
    if (menu) {
      me.AsynMenu.selectFn(code);
      storage.set('activeMenu', menu);
      if (url) me.refs.frame.contentWindow.location.href = url;
    }
  };
  window.HideAsynMenu = t => {
    me.setState({ sider: false });
  };
  window.addEventListener('message', msg => {
    if (new RegExp(`${window.location.hostname}|10.0.4.57`).test(event.origin)) {
      try {
        eval(msg.data);
      } catch (error) {
        console.error(error);
      }
    }
  }, false);
};

class BaseLayout extends React.Component {
  constructor(props) {
    super(props);
    const me = this;
    me.state = {
      collapsed: false,
      // 当前用户角色列表
      roles: [
        { 'userId': 1, 'roleId': 1, 'roleName': '管理员' },
        { 'userId': 1, 'roleId': 85, 'roleName': 'CRM销售经理' },
      ],
      // 当前活跃角色
      activeRole: {},
      wHeight: getWindowHeight(),
      // 菜单显示状态
      sider: true,
      roleName:'',
      scrollList:[]
    };
    me.resizeHandle();
    // 获取用户角色
    me.getUserRole();
    me.onRoleMenuClick = me.onRoleMenuClick.bind(me);
  }

  componentWillMount() {
    addEvent.call(this);
    this.factoryList()
  }

  // 获取用户角色
  getUserRole(userId) {
    // 用户登录信息
    const loginInfo = storage.get('loginInfo');
    controllerUserAPI.getUserRole({
      userId: loginInfo.userId,
    }).then(res => {
      if (res.code === __SUCCESS__) {
        this.setState({
          roles: res.data.userRoles,
        });
        // 获取用户角色菜单 不选择默认角色功能打开
        this.getRoleResourceList(this.findActiveRoleId(loginInfo.roleId));

        // 获取用户角色菜单 选择默认角色功能 打开
        // const loginSelectRoleId = storage.get('loginSelectRole');
        // this.getRoleResourceList(loginSelectRoleId.roleId);
        // this.setActiveRole(loginSelectRoleId)
      } else {
        message.error(res.message || '角色获取失败!');
      }
    });
  };

  // 获取左侧资源菜单
  getRoleResourceList(roleId) {
    // 获取菜单
    this.props.dispatch({
      type: 'common/getAllResourceListFn',
      payload: {
        'roleId': roleId,
        'supId': 1, // pc 菜单 id
      },
    }).then(res => {
      if (res.code !== __SUCCESS__) {
        message.error(res.message || '菜单获取失败!');
      }
    });
  };

  // 查找角色
  findRoleById(roleId) {
    const { roles } = this.state;
    return roles.find(r => r.roleId === roleId);
  };

  // 匹配当前活跃角色id
  findActiveRoleId(roleId) {
    const me = this;
    // 优先读缓存
    let role = storage.get('activeRole');
    // 匹配当前角色
    if (role) role = me.findRoleById(role.roleId);
    // 匹配不到缓存角色时,匹配传入角色
    if (!role) role = me.findRoleById(roleId);
    me.setActiveRole(role);
    return role.roleId;
  }

  resizeHandle() {
    const me = this;
    window.addEventListener('resize', t => {
      me.setState({
        wHeight: getWindowHeight(),
      });
    });
  }

  // 设置当前活跃角色
  setActiveRole(activeRole) {
    storage.set('activeRole', activeRole);
    this.setState({ activeRole });
  }

  onCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  // 加工滚动条的dom
  factoryList() {
      axios({
        method:'post',
        url:'https://sfadev.maydos.com.cn/mxmService/news/list',
        headers: { 'Content-Type': 'application/json'},
        data:{
          limit: 10,
          page: 1
        }
      }).then(res => {
        const {data} = res
        if(data && data.code == 0) {
          if(data.page && data.page.list && data.page.list instanceof Array) {
            const arr = data.page.list.map((val,index) => {
              return <span className={Less['white-space'] + ' ' + Less['padding-0-10'] + ' ' + Less['font-size-18']} key={index}>
                <a
                href={'https://sfadev.maydos.com.cn//edp-sys/index.html#/newsManagerList/detail/' + val.id}>
                {val.title}</a>
                </span>
            })
            this.setState({
              scrollList: arr
            })
          }
        }
    })
    // const list = [
    // <div className={'height-full width-400 margin-0-16 ' + Less['background-color-1']}>
    //   1
    // </div>,
    //  <div className={'height-full width-400 margin-0-16 ' + Less['background-color-2']}>
    //   2
    // </div>,
    // <div className={'height-full width-400 margin-0-16 ' + Less['background-color-3']}>
    //   3
    // </div>,
    // ]
    // return list;
  }

  onSamePageClick = menu => {
    this.props.dispatch({
      type: 'common/clickedMenuList',
      payload: {
        clickedMenu: menu,
      },
    })
    this.props.dispatch({
      type: 'common/setActiveKey',
      payload: {
        activeKey: menu.id,
      },
    })
    this.props.dispatch({
      type: 'common/setlocation',
      payload: {
        location: {pathname: menu.code},
      },
    })
  };

  // 导航栏菜单按钮
  onMainMenuClick(e) {
    const { dispatch, home, routerTag } = this.props;
    switch (e.key) {
      case 'modify':
        this.refs.ModifyModal.showModal();
        break;
      case 'home':
        dispatch(routerRedux.push(home[routerTag]));
        break;
      case 'reload':
        window.location.reload();
        break;
      case 'exit':
        dispatch(routerRedux.push('/login'));
        storage.clear('loginInfo');
        break;
      default:
        break;
    }
  }

  // 切换角色
  onRoleMenuClick(e) {
    const role = this.findRoleById(e * 1);
    this.setState({ sider: true });
    this.setActiveRole(role);
    // 切换角色
    controllerUser.setUserRole({
      roleId: role.roleId,
    }).then(res => {
      if (res.code === __SUCCESS__) {
        // 获取角色资源菜单
        this.getRoleResourceList(role.roleId);
        // 更新注册信息
        controllerUser.regist({
          'userName': storage.get('loginInfo').loginName,
        }).then(res => {
          if (res.code === __SUCCESS__) {
            // 获取角色资源菜单
            storage.set('registerInfo', res.data);
          } else {
            message.error(res.message || '更新注册信息失败!');
          }
        });
      } else {
        message.error(res.message || '角色切换失败!');
      }
    });
  }

  onRef = (ref) => {
    this.AsynMenu = ref;
  };
  tabEdit(menuId, action){
    let {clickedMenuList}=this.props
    if(action == 'remove'){
      let j = -1;
      clickedMenuList.forEach((item,i) => {
        if(item.id == menuId){
          j=i;
        }
      });
      j != -1 && clickedMenuList.splice(j,1);
      this.props.dispatch({
        type: 'common/editcClickedMenuList',
        payload: {
          clickedMenuList: clickedMenuList,
        },
      })
    }
  }
  onChangeTabMuen(menuId){
    this.props.dispatch({
      type: 'common/setActiveKey',
      payload: {
        activeKey: menuId,
      },
    })
    let {clickedMenuList}=this.props;
    let menu = {};
    clickedMenuList.forEach(item=>{
      if(item.id == menuId){
        menu = item
      }
    })
    this.props.dispatch({
      type: 'common/setlocation',
      payload: {
        location: {pathname: menu.code},
      },
    })
    window.top.location.href = window.location.origin +window.location.pathname + '#' +menu.code
  }
  render() {
    const { location, menusObj, loading, homeConfig } = this.props;
    const { roles, activeRole, wHeight } = this.state;
    // console.log('debug wHeight', wHeight);
    // console.log('activeKey=====', activeKey);
    // console.log('clickedMenuList=====', clickedMenuList);

    const siderHeight = wHeight - 64 - 50 ;
    // 用户登录信息
    const loginInfo = storage.get('loginInfo');
    const target = menusObj[location.pathname];

    // console.log('location======',this.props)
    // console.log('menusObj======',menusObj)
    // console.log('pathname======',location.pathname)
    // console.log('target======',target)
    // 主体区块
    let content = target && target.url && /^http/.test(target.url)
        ?
        <Content className={styles['content-box2']}>
          <iframe ref="frame"
            title="content"
            style={{ height: siderHeight }}
            src={target && target.url}></iframe>
        </Content>
        :
        <Content className={styles['content-box']}>
          {this.props.children}
        </Content>

    let bottomTitle = (homeConfig && homeConfig.bottomTitle && homeConfig.bottomTitle.confValue) || '@2019 云镖网络 版权所有 粤ICP备18130807号-1';
    let mainLogoId = (homeConfig && homeConfig.code === 0 && homeConfig.mainLogoId.confValue);
    let logoStyle = !!mainLogoId ? {
      'backgroundImage': `url(${mainLogoId})`,
      'backgroundRepeat': `no-repeat`,
      'backgroundPosition': `center`,
    } : null;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible
          trigger={null}
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
          className={styles['shadow-box']}>
          <div className={styles['sider-group']}>
            <div className={cx({ logo: true, collapsed: this.state.collapsed })} style={logoStyle}></div>
            <div className={styles['menu-box']}>
              {
                this.state.sider && <AsynMenu onRef={this.onRef} onSamePageClick={this.onSamePageClick}></AsynMenu>
              }
            </div>
          </div>
        </Sider>

        <Layout className={styles['site-layout']}>
          <Header style={{ padding: 0,display:'flex',alignItems: 'center'}}>
            &emsp;&nbsp;
            {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'ocss-trigger',
              onClick: this.onCollapse,
            })}
            &emsp;
            <Select placeholder="请选择角色" bordered={false} style={{minWidth:200}}
              showSearch value={activeRole.roleName || undefined}
              onChange={this.onRoleMenuClick.bind(this)}
              optionFilterProp="children"
              // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {roles.map(item => (
                <Select.Option value={String(item.roleId)} key={item.roleId} ><Button type="text" icon={<UserOutlined />}></Button>{item.roleName}</Select.Option>
              ))}
            </Select>
            <div style={{flex:1,overflow: 'hidden'}}>
                <ScrollComponent listImg={this.state.scrollList} speed={60}/>
            </div>
            <Menu theme="" onClick={this.onMainMenuClick.bind(this)} mode="horizontal" className="fr pr10 no-border">
              <Menu.Item key="1">您好,{loginInfo.userName}</Menu.Item>
              {/* TODO:刷新图标等隐藏  */}
              {/* <Menu.Item key="modify"><LockOutlined /></Menu.Item>
              <Menu.Item key="home"><HomeOutlined /></Menu.Item>
              <Menu.Item key="reload"><ReloadOutlined /></Menu.Item> */}
              <Menu.Item key="exit"><PoweroffOutlined /></Menu.Item>
            </Menu>
          </Header>
          {/* <div className={styles['munelist']}>
            <Tabs
              hideAdd
              onChange={this.onChangeTabMuen.bind(this)}
              type="editable-card"
              onEdit={this.tabEdit.bind(this)}
              className='munelist-card'
              activeKey={activeKey+''}
            >
              {
                clickedMenuList.map(pane => (
                  <TabPane tab={pane.name} key={pane.id} ></TabPane>
                ))
              }
            </Tabs>
          </div> */}
          {content}
          <Footer>
            <div className="mg-at fs12 gray tc">{bottomTitle}</div>
          </Footer>
        </Layout>

        <ModifyPwd ref="ModifyModal"></ModifyPwd>
        {loading.global ? <div className={styles['spin-wrapper']}><Spin className="absolute tr50 lr50"
          size="large"
          delay={100}
          tip="Loading..." /></div> : ''}
      </Layout>
    );
  }
}

BaseLayout.propTypes = {
  location: PropTypes.object.isRequired,
};
export default connect(({ common, loading }) => {
  return { ...common, loading };
})(BaseLayout);
